import { render, staticRenderFns } from "./waybill.vue?vue&type=template&id=14708f4c&scoped=true&"
import script from "./waybill.vue?vue&type=script&lang=js&"
export * from "./waybill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14708f4c",
  null
  
)

export default component.exports